export const healthStatuses = {
  RUNNING: {
    text: 'Running',
    color: 'GREEN',
  },
  NOT_RUNNING: {
    text: 'Not Running',
    color: 'RED',
  },
  GREEN: {
    text: '',
    color: 'GREEN',
  },
  RED: {
    text: '',
    color: 'RED',
  },
  ORANGE: {
    text: '',
    color: 'ORANGE',
  },
  GREY: {
    text: '',
    color: 'GREY',
  },
};
